module.exports = {
  FormData: globalThis.FormData,
  File: globalThis.File,
  Blob: globalThis.Blob
};
